var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container"},[_c('h2',{staticClass:"tokens-page__title"},[_vm._v(" "+_vm._s(_vm._f("globalize")('tokens-page.title'))+" ")]),_c('token-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }